webpackJsonp([162898551421021],{

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)({
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'center',
	        minHeight: '60vh',
	        padding: '40px 15px'
	      })
	    },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        '404 Page Not Found \u2013 Patr\xEDcia Marques'
	      ),
	      _react2.default.createElement('meta', { name: 'descritpion', value: 'I\'m sorry but the page you\'re looking for is not there.' })
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Page not found'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'m sorry. The page you\'re looking for has either been moved, deleted or has never existed. Use the links below to go somewhere nicer.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: 'portfolio', className: _styles.Button },
	      'Portfolio'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/', className: _styles.ButtonOutline },
	      'Home'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-80fa52b18b5c609254fe.js